
import Vue from "vue";
import { data } from "@/model/Data";
import { VueEllipseProgress } from "vue-ellipse-progress";


var hexRange: string[] = [];
const digits = "0123456789abcdef".split("");
digits.forEach((outer) => {
    digits.forEach((inner) => {
        hexRange.push(outer + inner);
    });
});


export default Vue.extend({
    data: () => ({
        data,
        tests: Object.keys(data.scores)
    }),

    methods: {
        rgbToHex(...vals: number[]) {
            //Split up the RGB(A) string on commas and match numbers
            let invalid = false;

            //Make sure none of the numbers are larger than 255
            vals.forEach((val) => {
                if (val > 255 || val < 0) invalid = true;
            });

            if (invalid) return "#caabff";

            //Make sure we have 3 or 4 numbers (RGB or RGBA)
            if ([3, 4].includes(vals.length)) {
                let finalHex = "";
                vals.forEach((color) => {
                    //If we're dealing with the alpha value…
                    color = Math.ceil(color);

                    hexRange.forEach((hex, hexIndex) => {
                        if (color == hexIndex) finalHex += hex;
                    });

                });
                return `#${finalHex}8f`;
            }
        }
    },

    computed: {
        passed() {
            var count = 0;

            for (var test in data.scores) 
                count += (data.scores[test] >= 50) ? 1 : 0;

            return count;
        },

        loaded() {
            
            for (var test in data.scores) 
                if (data.scores[test] == -1) return false;

            return true;
        },

        message() {
            var percent = this.passed / this.tests.length * 100;
            if (percent >= 80) return "You probably do not have Alzheimer's";
            else if (percent >= 50) return "You might not have Alzheimer's";
            else if (percent >= 20) return "You might have Alzheimer's";
            else return "You most likely have Alzheimer's";
        }
    },

    components: {VueEllipseProgress},
});
